export * from './basic-template.props';
export * from './basic-template';
